import React from "react";

import { styled } from "@mui/material";
import CropFreeIcon from "@mui/icons-material/CropFree";
import Height from "@mui/icons-material/Height";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";
import ListAltIcon from "@mui/icons-material/ListAlt";
import QueueOutlinedIcon from "@mui/icons-material/QueueOutlined";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import TabIcon from "@mui/icons-material/Tab";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import LooksOne from "@mui/icons-material/LooksOne";
import TextFields from "@mui/icons-material/TextFields";
import Flag from "@mui/icons-material/Flag";

import { ARRAY, OBJECT, NUMBER, STRING, BOOLEAN, CONST, SchemaElementType } from "../model";

export const VerticalIcon = Height;
export const HorizontalIcon = styled(Height)({
	transform: "rotate(90deg)",
});
export const GroupIcon = CropFreeIcon;
export const CategorizationIcon = TabIcon;
export const CategoryIcon = CropFreeIcon;

export const LabelIcon = TextFieldsIcon;

export const ControlIcon = InsertLinkIcon;
export const ObjectIcon = ListAltIcon;
export const ArrayIcon = QueueOutlinedIcon;
export const OtherIcon = RadioButtonUncheckedIcon;
export const NumberIcon = LooksOne;
export const StringIcon = TextFields;
export const BooleanIcon = Flag;
export const ConstIcon = LabelOutlinedIcon;

export const getIconForSchemaType = (type: SchemaElementType) => {
	switch (type) {
		case OBJECT:
			return ObjectIcon;
		case ARRAY:
			return ArrayIcon;
		case NUMBER:
			return NumberIcon;
		case STRING:
			return StringIcon;
		case BOOLEAN:
			return BooleanIcon;
		case CONST:
			return ConstIcon;
		default:
			return OtherIcon;
	}
};

export const getIconForUISchemaType = (type: string) => {
	switch (type) {
		case "HorizontalLayout":
			return HorizontalIcon;
		case "VerticalLayout":
			return VerticalIcon;
		case "Group":
			return GroupIcon;
		case "Category":
			return CategoryIcon;
		case "Categorization":
			return CategorizationIcon;
		case "Control":
			return ControlIcon;
		case "Label":
			return LabelIcon;
		default:
			return OtherIcon;
	}
};

interface UISchemaIconProps {
	type: string;
}
export const UISchemaIcon: React.FC<UISchemaIconProps> = ({ type }) => {
	return React.createElement(getIconForUISchemaType(type), {});
};

interface SchemaIconProps {
	type: SchemaElementType;
}
export const SchemaIcon: React.FC<SchemaIconProps> = ({ type }) => {
	return React.createElement(getIconForSchemaType(type), {});
};
